import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
// import GenexHelperMixins from "@/mixins/GenexHelperMixins";
// import Module from "@/models/lms/Module";
// import Course from "@/models/lms/Course";

export default class ModuleEntity extends GenexLMSModel {
    static entity = 'module-entities'

    static fields() {
        return {
            type: this.attr(""),
            id: this.attr(null),
            module_id: this.attr(null),
            moduleable_type: this.attr(""),
            moduleable_id: this.attr(null),
            order: this.attr(null),
            is_restricted: this.attr(null),
            created_at: this.attr(""),
            updated_at: this.attr(""),
            moduleable: this.morphTo('moduleable_id', 'moduleable_type')
        }
    }

}
